import React, { ReactNode } from 'react';

interface CardProps {
	title?: string;
	subtitle?: string;
	children: ReactNode;
	className?: string;
	action?: ReactNode;
}

const Card: React.FC<CardProps> = ({
	title,
	subtitle,
	children,
	className = '',
	action
}) => {
	return (
		<div className={`bg-white dark:bg-gray-800 rounded-xl shadow-md  ${className}`}>
			{(title || action) && (
				<div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center justify-between">
					<div>
						{title && (
							<h3 className="text-lg font-semibold text-gray-900 dark:text-white">
								{title}
							</h3>
						)}
						{subtitle && (
							<p className="mt-1 text-sm text-gray-500 text-blue dark:text-gray-400">
								{subtitle}
							</p>
						)}
					</div>
					{action && (
						<div className="mt-3 sm:mt-0">
							{action}
						</div>
					)}
				</div>
			)}
			<div className="p-6 h-full">
				{children}
			</div>
		</div>
	);
};

export default Card;